import { render, staticRenderFns } from "./activity-groups.vue?vue&type=template&id=0fd001b1"
import script from "./activity-groups.vue?vue&type=script&lang=js"
export * from "./activity-groups.vue?vue&type=script&lang=js"
import style0 from "./activity-groups.vue?vue&type=style&index=0&id=0fd001b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports